'use strict';
import MAGSidebar from './src/mag-sidebar.vue';
export default MAGSidebar